import { render, staticRenderFns } from "./ImportDataFor.vue?vue&type=template&id=75270aa0&scoped=true&"
import script from "./ImportDataFor.vue?vue&type=script&lang=js&"
export * from "./ImportDataFor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75270aa0",
  null
  
)

export default component.exports